import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigSettingsService } from '../../../providers/config-settings/config-settings.service';
import { Authenticator } from '../interface';
import { CodeGrantAuthService, PasswordGrantAuthService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationFacade implements Authenticator {
  private readonly configService = inject(ConfigSettingsService);
  private readonly codeGrantAuthService = inject(CodeGrantAuthService);
  private readonly passwordGrantAuthService = inject(PasswordGrantAuthService);

  // Resolved lazily on access because the active grant is determined by AppSettings,
  // which is populated after ConfigSettingsService loads (post-construction).
  public get authenticationChange$(): Observable<boolean> {
    return this._authenticator.authenticationChange$;
  }

  private get _authenticator(): Authenticator {
    return this.configService.appSettings.isOAuthCodeGrantSupported
      ? this.codeGrantAuthService
      : this.passwordGrantAuthService;
  }

  public authenticate(username?: string, password?: string, releaseCode?: string): Promise<void> {
    return this._authenticator.authenticate(username, password, releaseCode);
  }

  public initialize(): Promise<void> {
    return this._authenticator.initialize();
  }

  public isAuthenticated(): Promise<boolean> {
    return this._authenticator.isAuthenticated();
  }

  public logout(): Promise<void> {
    return this._authenticator.logout();
  }

  public getAccessToken(): Promise<string | undefined> {
    return this._authenticator.getAccessToken();
  }
}
